import { clearAuth as clearCCAuth } from '../Apps/CC/Config/Auth';
import { clearAuth as clearHSAuth } from '../Apps/HS/Config/Auth';
import { clearAuth as clearTCAuth } from '../Apps/TC/Config/Auth';

export const handleLogout = () => {
    clearCCAuth();
    clearHSAuth();
    clearTCAuth()

    window.location.href = "/";
};
